import Navbar from "../components/Navbar";
import '../css/home.css';
import Footer from "../components/Footer";
import Landing from "../components/Landing";
import BackToTop from "../components/BackToTop";
import Banner from "../components/Banner";
import BTSwamiSpace from "../assets/BT_SWAMI_Portraits/BTSwami-Waterfall.jpg";

export default function Home() {
    return (
        <>
            <Navbar />
            <div className="video-container">
                <Banner
                    imagePath={BTSwamiSpace}
                    content={
                    <div className="quote-carousel">
                            <p>
                                As we offer service to others with no expectation of reward, the lord in the heart becomes more available to us and provides for our needs... 
                            </p>
                            <p>
                                Genuine love is not concerned with personal gain, but rather with the quality of the exchange between those involved... 
                            </p>
                            <p>
                                Humility does not mean to think yourself less, but to less think of yourself... 
                            </p>
                    </div>
                    }
                    alignment="right"
                />
            </div>
            <Landing />
            <BackToTop/>
            {/* <ContactForm /> */}
            <Footer />
        </>
    );
}